import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=331d1cb1&scoped=true&"
import script from "./custom.vue?vue&type=script&lang=js&"
export * from "./custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331d1cb1",
  null
  
)

export default component.exports